import axios from 'axios';

// Send a new message
export const sendMessage = async ({ conversationId, text, storyId, story, token }) => {
  try {
    const messageData = {
      conversationId,
      type: 'text',
      content: {
        text: text
      }
    };

    // Include story data if provided
    if (story) {
      messageData.story = story;
    } else if (storyId) {
      messageData.storyId = storyId;
    }

    const { data } = await axios.post(
      '/api/messenger/messages',
      messageData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

// Get messages between current user and another user
export const getMessages = async (conversationId, token) => {
  try {
    const { data } = await axios.get(`/api/messenger/conversations/${conversationId}/messages`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

// Get all conversations for the current user
export const getConversations = async (token) => {
  try {
    const { data } = await axios.get('/api/messenger/conversations', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.error('Error fetching conversations:', error);
    throw error;
  }
};

// Mark messages as read
export const markAsRead = async (conversationId, messageIds, token) => {
  try {
    const { data } = await axios.put(
      `/api/messenger/conversations/${conversationId}/read`,
      { messageIds },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error('Error marking messages as read:', error);
    throw error;
  }
};

// Delete a message
export const deleteMessage = async (messageId, token) => {
  try {
    const { data } = await axios.delete(`/api/messenger/messages/${messageId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.error('Error deleting message:', error);
    throw error;
  }
};

// Get message by ID
export const getMessage = async (messageId, token) => {
  try {
    const { data } = await axios.get(`/api/messenger/messages/${messageId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.error('Error fetching message:', error);
    throw error;
  }
};
